<template>
    <div :class="{'Avatar': true, 'UserEntry': IsUserMessage, 'AiEntry': IsAiMessage}">
        {{ IsUserMessage ? 'U' : 'AI' }}
    </div>
    <div :class="{'ChatHistoryEntry': true, 'UserEntry': IsUserMessage, 'AiEntry': IsAiMessage}"
         v-html="MessageContent">
    </div>
    <div v-if="IsUserMessage === false" :class="{'BadFeedback': true, 'ChatHistoryEntry': true, 'UserEntry': IsUserMessage, 'AiEntry': IsAiMessage}">
        <span class="BadResponseBtn" title="AIの返信は合ってないか上手く出来ませんでした場合、このボタンを押してください。" @click="OnRateButton">👎</span>
    </div>
</template>

<script>
export default{
    props:{
        Message: Object,
        MessageID: Number,
        OnFeedback: Function,
    },
    computed:{
        IsUserMessage()
        {
            return this.Message.role === 'user';
        },
        IsAiMessage()
        {
            return this.Message.role !== 'user';
        },
        MessageContent()
        {
            return this.Message.content.replaceAll(/\\\\n/g, '\n').replaceAll(/\n/g, '<br>').replaceAll('\\n', '').replaceAll('"\\"', '').replaceAll('\\""', '');
        }
    },
    // mounted(){
    //     console.log('message', this.Message.content);
    // },
    methods:{
        OnRateButton()
        {
            this.OnFeedback(this.MessageID);
        }
    }
}
</script>

<style>
.ChatHistoryEntry
{
    padding: 16px 10px;
    border-radius: 10px;
    box-shadow: 2px 2px 2px 2px rgba(0.5, 0.5, 0.5, 0.2);
}

.Avatar + .ChatHistoryEntry
{
    margin-top: 8px;
}

.ChatHistoryEntry + .Avatar
{
    margin-top: 25px;
}

.UserEntry
{
    background-color: #4ea883;
    color: #fff;
    text-align: right;
    margin-left: auto;
}

.AiEntry
{
    background-color: aliceblue;
    color: #000;
    text-align: left;
}

.Avatar
{
    border-radius: 50%;
    width: 40px;
    height: 40px;
    place-content: center;
    text-align: center;
    font-weight: bold;
}

.BadFeedback
{
    float: left;
    width: 22px;
    height: 22px;
    place-content: center;
    display: flex;
    padding: 5px;
}

.BadResponseBtn
{
    cursor: pointer;
    transition: 0.2s;
    -moz-transition: 0.2s;
    -webkit-transition: 0.2s;
    font-size: 100%;
}

.BadResponseBtn:hover
{
    font-size: 130%;
}
</style>